module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm"
    }
  }, [_c('span', {
    attrs: {
      "id": "page1"
    }
  }, [_c('p', {
    staticClass: "center0"
  }, [_vm._v("Lynn Newman has a gif of large perception.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "blue1"
  }, [_vm._v("Natalie Goldberg, author of "), _c('em', [_vm._v("Writing Down the Bones")])])]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_vm._v("Because Lynn knows her own creativity deep")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("from the inside, she is able to creatively inspire others")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("to explore and discover their freest selves.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "blue1"
  }, [_vm._v("Michele Cassou, author of "), _c('em', [_vm._v("Life, Paint and Passion")])])]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_vm._v("Part memoir and part workbook, "), _c('em', [_vm._v("The Muse in You")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("may be just what you need to heal from your pain and be")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("reborn as someone more passionate, purposeful, and alive.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "blue1"
  }, [_vm._v("Lori Deschene, author of "), _c('em', [_vm._v("Tiny Buddha’s Worry Journal")]), _vm._v(" and others")])]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_vm._v("There is no better guide than Lynn for helping you")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("befriend your inner muse. Lynn’s priceless combination")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("of humor, vulnerability, and straight-up truth-telling")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("will inspire you to overcome life’s challenges … a beacon of")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("hope, a fountain of wisdom, and a treasure of tools to call")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("out your inner creative strength and resiliency.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "blue1"
  }, [_vm._v("Heather Ash Amara, author of "), _c('em', [_vm._v("Warrior Goddess Training")])]), _c('span', {
    attrs: {
      "id": "page2"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cf38738","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c02_fm.vue
// module id = 57
// module chunks = 0